"use client";
import { useState, useRef, useEffect } from "react";

export default function ExpandableText({ text, maxHeight = "4rem" }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsExpand, setNeedsExpand] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setNeedsExpand(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [text]);

  return (
    <div className="shadow-sm rounded-lg relative m-5 p-5 text-left flex flex-col">
      {/* Contenedor del texto */}
      <div
        ref={textRef}
        className={`overflow-hidden transition-all ${
          isExpanded ? "max-h-full" : "max-h-32"
        }`}
        style={{ maxHeight: isExpanded ? "none" : maxHeight }}
      >
        <p className="whitespace-pre-line text-pretty">{text}</p>
      </div>

      {/* Gradiente solo si se necesita expandir */}
      {!isExpanded && needsExpand && (
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      )}

      {/* Botón solo si se necesita expandir */}
      {needsExpand && (
        <button
          onPress={() => setIsExpanded(!isExpanded)}
          className="text-sm text-blue-600 hover:text-blue-800 self-end mt-2"
        >
          {isExpanded ? "Ver menos" : "Ver más"}
        </button>
      )}
    </div>
  );
}
